import styled from "styled-components";

export const Container = styled.div`
    height: 24.063rem;
    margin-bottom: 2rem;
    color: #333333;
    display: flex;
    margin-top: 1rem;
`;

export const CardContainer = styled.div`
    width: 50%;
    align-content: left;
`;

export const TopCards = styled.div`
    height: 50%;
    display: flex;
    flex-direction: row;
`;

export const BottomCards = styled.div`
    height: 50%;
    display: flex;
    flex-direction: row;
    margin-top: 12px;
`;

export const Card = styled.div`
    width: 260px;
    height: 180px;  
    background-color: #FFFFFF;
    box-shadow: 0px 1px 1px #00000029;
    border-radius: 6px;
    align-items: center;
    text-align: center;
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 25px;
`;

export const Circle = styled.div`
    background: ${props => `linear-gradient(33deg, ${props.colors[0]} 0%, ${props.colors[1]} 100%)`};
    color: white;
    margin: 20px auto;
    align-items: center;
    text-align: center;
    border-radius: 100%;
    width: 60px;
    height: 60px;
    
    > svg {
        font-size: 50px
    }
`;

export const GraphicContainer = styled.div`
    height: 100%;
    width: 50%;
    background-color: #FFFFFF;
    box-shadow: 0px 1px 1px #00000029;
    border-radius: 6px;

    @media(min-width: 1600px) {
        width: 90%;
    }
`;

export const GraphicTitle = styled.div`
    height: 10%;
    text-align: left;
    margin-left: 20px;
    margin-right: 20px;
    padding: 12px 0px;
    border-bottom: 1px solid #CCCCCC;

    > h4 {
        font-size: 18px;
        color: #434343;
        font-weight: bold;
    }
`;

export const Title = styled.h5`
    font-size: 18px;
`;

export const SubTitle = styled.h5`
    font-size: 23px;
    font-weight: 900;
`;

export const Div1 = styled.div`
    width: 100%;
    height: 50%;
    justify-content: space-between;
    display: flex;
    padding: 0 15px;
    align-content: center;
    align-items: center;
    >div{
      
    }
`;

export const Div2 = styled.div`
    width: 100%;
    height: 50%;
    text-align: left;
    padding: 10px;
    display: flex;
    align-items: flex-end;
`;

export const DivNumber = styled.div`
    width: 60%;
    text-align: right;
    >h5{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;